module.exports = {"list_title":"标签管理","tt_id":"工单号","tt_quantity":"数量","tt_time":"创建时间"}


//////////////////
// WEBPACK FOOTER
// ./src/i18n/zh-CN-plan.json
// module id = 602
// module chunks = 21